import React from 'react';

import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import WebformPage from '../Page';
import type { Submission, IMap } from '../types';

import './style.scss';

export interface WebformMapperProps {
  entities: IMap
  exerciseSubmission: Submission
  hideLabels?: boolean
}

const WebformMapper: React.FC<WebformMapperProps> = ({
  entities,
  exerciseSubmission,
  hideLabels,
  ...props
}) => (
  <>
    {entities.valueSeq().map((entity: IMap) => {
      const type = entity.get('#type') as string;
      const key = entity.get('#webform_key') as string;

      switch (type) {
        case 'webform_wizard_page': {
          return (
            <WebformPage
              key={key}
              entities={entity}
              exerciseSubmission={exerciseSubmission}
              WebformMapper={WebformMapper}
              hideLabels={hideLabels}
              {...props}
            />
          );
        }

        case 'markup':
        case 'processed_text': {
          return (
            <WysiwygField
              key={key}
              property="schema:text"
              html={entity.get('#text', '')}
            />
          );
        }

        case 'textarea':
        case 'textfield': {
          const title = (!hideLabels ? entity.get('#title') : null) as string;
          const answer = exerciseSubmission?.data?.[key];

          if (!answer) {
            return null;
          }

          return (
            <>
              {title && <h3>{title}</h3>}
              {entity.get('#multiple', false) ? (
                <ul key={key}>
                  {Object.entries(answer).map(([delta, item]) => (
                    item.length > 0 && <li key={`${key}:${delta}`}>{item}</li>
                  ))}
                </ul>
              ) : (
                <p>{answer}</p>
              )}
            </>
          );
        }

        case 'hidden':
        case 'webform_actions':
        default: {
          return null;
        }
      }
    })}
  </>
);

export default WebformMapper;
